const appConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  ASSOCIATE_URL: process.env.REACT_APP_ASSOCIATE_URL,
  MAP_BOX_API_URL: process.env.REACT_APP_MAP_BOX_API_URL,
  MAP_BOX_GEOCODING_URL: process.env.REACT_APP_MAP_BOX_GEOCODING_URL,
  MAP_BOX_API_TOKEN: process.env.REACT_APP_MAP_BOX_API_TOKEN,
};

export const config = { ...appConfig };
